module.exports = __webpack_public_path__ + "img/social-in-test.1829f4ad.png";